import React from 'react';
import { Navigate } from 'react-router-dom';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const user = localStorage.getItem('user');

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  try {
    const userObject = JSON.parse(user);
    // Vérifier si l'objet user existe et a au moins une propriété
    if (!userObject || Object.keys(userObject).length === 0) {
      localStorage.removeItem('user');
      localStorage.removeItem('mail');
      return <Navigate to="/login" replace />;
    }
  } catch (error) {
    console.error('Erreur lors de la lecture du user:', error);
    localStorage.removeItem('user');
    localStorage.removeItem('mail');
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;